import React from 'react'
import { Routes, Route } from "react-router-dom";
// import EditAchievement from "../Certificate/EditAchievement";
import AddCertificate from '../Certificate/AddCertificate';
import CertificateList from '../Certificate/CertificateList';
// import AchievementDetails from '../Certificate/AchievementDetails';
import { useLocation } from 'react-router-dom';
import { Location } from '../Certificate/LocationContext';
// import Achivementpdf from '../Certificate/Achivementpdf';
// import AchievementView from '../Certificate/AchievementView';
import Login from '../Certificate/Login';
import EnglishCertificate from '../Certificate/EnglishCertificate';
import BengaliCertificate from '../Certificate/BengaliCertificate';
import StatusApplication from '../Certificate/StatusApplication';
import CertificateCheck from '../Certificate/CertificateCheck';
import ApplicationDetails from '../Certificate/ApplicationDetails';



const Index = () => {
  const location = useLocation()
  return (
    <Location.Provider value={location}>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/certificate-list" element={<CertificateList />} />
        <Route path="/add-certificate" element={<AddCertificate />} />
        <Route path="/Ecertificate-download" element={<EnglishCertificate />} />
        <Route path="/Bcertificate-download" element={<BengaliCertificate />} />
        <Route path="/status-of-application" element={<StatusApplication />} />
        <Route path="/certificate-check" element={<CertificateCheck/>} />
        <Route path="/application-details" element={<ApplicationDetails/>} />
  


      </Routes>
    </Location.Provider>
  )
}

export default Index
